import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { ReactComponent as MyPointsIcon } from 'src/assets/icons/myPoints.svg';
import { ReactComponent as MyRankingIcon } from 'src/assets/icons/myRanking.svg';
import styles from '../index.module.scss';

function IndividualRankingCard({ individualRanking }) {
  return (
    <div className={styles.leaderboard__individual}>
      <div className={styles.leaderboard__individual__card}>
        <MyRankingIcon />{' '}
        <div className={styles.leaderboard__individual__card__info}>
          <Text>{individualRanking?.rank?.name}</Text>
          <Text type="h5">{individualRanking?.rank?.value}</Text>
        </div>
      </div>
      <div className={styles.leaderboard__individual__card}>
        <MyPointsIcon />{' '}
        <div className={styles.leaderboard__individual__card__info}>
          <Text>{individualRanking?.points?.name}</Text>
          <Text type="h5">{individualRanking?.points?.value}</Text>
        </div>
      </div>
    </div>
  );
}

export default IndividualRankingCard;
